window.openVersionGuideModal = function (triggerEl) {
  if (!triggerEl) return false;
  var wrapper = triggerEl.closest("m-version-guide");
  if (!wrapper) return false;
  var popup = wrapper.querySelector(".m-version-guide-popup");
  if (!popup) return false;
  var content = popup.innerHTML;
  if (!content || !content.trim()) return false;

  var existing = document.querySelector(".version-guide-custom-modal");
  if (existing) existing.remove();

  var modal = document.createElement("div");
  modal.className = "version-guide-custom-modal";
  modal.innerHTML =
    '<div class="version-guide-custom-modal__backdrop" data-vg-close></div>' +
    '<div class="version-guide-custom-modal__dialog" role="dialog" aria-modal="true" aria-label="Version guide">' +
    '<button type="button" class="version-guide-custom-modal__close" aria-label="Close" data-vg-close>&times;</button>' +
    '<div class="version-guide-custom-modal__content"></div>' +
    "</div>";

  var contentRoot = modal.querySelector(".version-guide-custom-modal__content");
  contentRoot.innerHTML = content;
  contentRoot.querySelectorAll(".product-compare-wrapper").forEach(function (item) {
    item.removeAttribute("data-enhanced");
  });

  var scripts = contentRoot.querySelectorAll("script");
  scripts.forEach(function (oldScript) {
    var newScript = document.createElement("script");
    Array.prototype.slice.call(oldScript.attributes).forEach(function (attr) {
      newScript.setAttribute(attr.name, attr.value);
    });
    if (oldScript.textContent) newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });

  if (!document.getElementById("version-guide-custom-modal-style")) {
    var style = document.createElement("style");
    style.id = "version-guide-custom-modal-style";
    style.textContent =
      ".version-guide-custom-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;}" +
      ".version-guide-custom-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55);}" +
      ".version-guide-custom-modal__dialog{position:relative;z-index:1;width:min(92vw,960px);max-height:90vh;overflow:auto;background:#fff;border-radius:10px;padding:20px;}" +
      ".version-guide-custom-modal__close{position:absolute;top:10px;right:12px;font-size:26px;line-height:1;border:0;background:transparent;cursor:pointer;color:#222;}" +
      ".version-guide-custom-modal__content{margin-top:12px;}";
    document.head.appendChild(style);
  }

  var closeModal = function () {
    modal.remove();
    document.removeEventListener("keydown", onEsc);
  };
  var onEsc = function (e) {
    if (e.key === "Escape") closeModal();
  };
  modal.querySelectorAll("[data-vg-close]").forEach(function (el) {
    el.addEventListener("click", closeModal);
  });
  document.addEventListener("keydown", onEsc);
  document.body.appendChild(modal);
  return false;
};

if (!customElements.get("m-version-guide")) {
  customElements.define(
    "m-version-guide",
    class MVersionGuide extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          openButton: "[data-open-version-guide]",
          content: ".m-version-guide-popup"
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        if (!this.domNodes.openButton || !this.domNodes.content) return;
        this.init();
      }

      init() {
        this.domNodes.openButton.addEventListener("click", (e) => {
          e.preventDefault();
          window.openVersionGuideModal(this.domNodes.openButton);
        });
      }
    }
  );
}
